import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiListItemAvatar from '@material-ui/core/ListItemAvatar';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { ListItemAvatarStyle } from './styles';
import { RcListItemAvatarClasses } from './utils';
var _RcListItemAvatar = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcListItemAvatar' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcListItemAvatarClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiListItemAvatar, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcListItemAvatar = styled(_RcListItemAvatar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ListItemAvatarStyle);
RcListItemAvatar.defaultProps = {};
RcListItemAvatar.displayName = 'RcListItemAvatar';
export { RcListItemAvatar };
var templateObject_1;
